import type { RegionKey, USState } from '../types';

export interface RegionMeta {
  key: RegionKey;
  state: USState;
  title: string;
  shortTitle: string;
  subtitle: string;
  mood: string;
  accent: string;
  bestFor: string[];
}

export const REGIONS: RegionMeta[] = [
  {
    key: 'portland-foothills-truffle-zone',
    state: 'OR',
    title: 'Portland Foothills and Estacada Zone',
    shortTitle: 'Portland / Estacada',
    subtitle:
      'Portland adds a city-base route pattern: seasonal pickup forays, PSU market stops, and downtown stays that work without a full wine-country overnight.',
    mood: 'Coffee-shop pickup points, wet foothill forests, downtown hotel returns, and a more urban rhythm than the valley weekend.',
    accent: 'Fir green, basalt gray, market cream',
    bestFor: ['Portland day trips', 'Guided forays', 'City-base stays', 'Winter Saturdays'],
  },
  {
    key: 'willamette-valley-truffle-corridor',
    state: 'OR',
    title: 'Willamette Valley Truffle Corridor',
    shortTitle: 'Willamette Valley',
    subtitle:
      'Newberg, McMinnville, and Dayton form the clearest truffle weekend in Oregon: forest access, strong hotels, and a finish that still feels like wine country.',
    mood: 'Douglas fir forests, cellar doors, chef-led dining rooms, and backroads that still feel worth the detour.',
    accent: 'Fir green, cellar brown, fog silver',
    bestFor: ['Winter truffle weekends', 'Private hunts', 'Wine-country stays', 'Chef-driven finales'],
  },
  {
    key: 'eugene-festival-truffle-zone',
    state: 'OR',
    title: 'Eugene Festival and Dog Training Zone',
    shortTitle: 'Eugene',
    subtitle:
      'Eugene adds an event-driven Oregon route pattern: ticketed truffle-dog events, training weekends, and city-based stays tied to festival travel.',
    mood: 'Lane Events Center mornings, training fields west of town, downtown hotel bases, and a more event-driven rhythm than wine-country touring.',
    accent: 'Forest green, arena tan, rain gray',
    bestFor: ['Festival weekends', 'Dog training', 'Downtown hotel stays', 'Southern route travel'],
  },
  {
    key: 'corvallis-truffle-science-zone',
    state: 'OR',
    title: 'Corvallis Truffle Science Zone',
    shortTitle: 'Corvallis',
    subtitle:
      'Corvallis adds a lighter academic leg built around NATS meetings, annual society events, and campus-adjacent stay logistics rather than polished tourism packaging.',
    mood: 'Cordley Hall evenings, society calendars, research-language truffle culture, and a more seminar-driven rhythm than the rest of the guide.',
    accent: 'Moss green, lecture-hall tan, rain gray',
    bestFor: ['Public talks', 'Academic travelers', 'Society events', 'Research-minded weekends'],
  },
];

export function getRegion(key: RegionKey): RegionMeta | undefined {
  return REGIONS.find((region) => region.key === key);
}
